import React from "react";

const LoadingScreen = () => {
  return (
    <div className="min-h-screen flex items-center justify-center relative overflow-hidden">
      {/* Background gradient circles */}
      <div className="absolute inset-0 z-0">
        <div className="absolute top-0 left-32 w-[700px] h-[700px] rounded-full bg-gradient-to-br from-peachYellow/40 to-salmonPink/40 blur-[100px] animate-pulse"></div>
        <div
          className="absolute -bottom-32 right-32 w-[700px] h-[700px] rounded-full bg-gradient-to-tl from-coralRed/40 to-roseBrown/40 blur-[100px] animate-pulse"
          style={{ animationDelay: "1s" }}
        ></div>
        <div
          className="absolute top-32 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[700px] h-[700px] rounded-full bg-gradient-to-tr from-salmonPink/30 to-peachYellow/30 blur-[100px] animate-pulse"
          style={{ animationDelay: "2s" }}
        ></div>
      </div>

      {/* Loading content */}
      <div className="relative z-10 text-center">
        <div className="w-24 h-24 mx-auto mb-8 relative">
          <div className="absolute inset-0 border-4 border-peachYellow rounded-full animate-spin border-t-transparent"></div>
          <div
            className="absolute inset-0 border-4 border-coralRed rounded-full animate-spin border-t-transparent"
            style={{ animationDelay: "0.2s" }}
          ></div>
          <div
            className="absolute inset-0 border-4 border-roseBrown rounded-full animate-spin border-t-transparent"
            style={{ animationDelay: "0.4s" }}
          ></div>
        </div>
        <h2 className="text-2xl font-bold bg-clip-text text-transparent bg-gradient-to-r from-peachYellow via-coralRed to-roseBrown">
          {`Solving humanity's problems...`}
        </h2>
      </div>
    </div>
  );
};

export default LoadingScreen;
